export const BAR_PADDING_X = 2;
export const BAR_PADDING_Y = 1.5;
export const BAR_TABLE_GAP = 2;

export const CURRENCY_KEYS = [
  "[Spend]",
  "spend",
  "commodity_increase",
  "value",
];
export const PERCENTAGE_KEYS = [
  "[Dynamic_Pareto]",
  "[Average_Last_Allocation]",
];
export const BOOLEAN_KEYS = ["is_total"];

export const SUPPLIER_COLUMNS = [
  {
    key: "Supplier[Normalized Supplier Name]",
    label: "Normalised Supplier Name",
  },
  { key: "[Spend]", label: "Spend" },
  { key: "[Dynamic_Pareto]", label: "Cumulative %" },
];

export const DEPARTMENT_COLUMNS = [
  { key: "department", label: "Department" },
  { key: "spend", label: "Spend" },
];

export const BUSINESS_UNIT_COLUMNS = [
  { key: "Business Unit[Business Unit]", label: "Business Unit" },
  { key: "[Spend]", label: "Spend" },
];

export const PROCUREMENT_LEVERS_COLUMNS = [
  { key: "lever", label: "Lever" },
  { key: "strength", label: "Strength" },
];

export const DEMAND_METRICS_CONFIG = [
  { key: "Materiality Summary", label: "Materiality" },
  { key: "Growth Summary", label: "Growth" },
  { key: "Fragmentation Summary", label: "Fragmentation" },
  { key: "Churn Summary", label: "Churn" },
];

export const COST_DRIVERS_COLUMNS = [
  { key: "Inflation Indices[Index]", label: "Inflation Indices" },
  { key: "[Average_Last_Allocation]", label: "Average Last Allocation" },
];

export const INFLATION_OVERVIEW_COLUMNS = [
  { key: "metric", label: "Metric" },
  { key: "value", label: "Value" },
];
export const COMMODITY_INFLATION_COLUMNS = [
  { key: "index", label: "Index" },
  { key: "commodity_increase", label: "Commodity Increase" },
];
